import type { CertificateResponse, DocumentResponseBody, TransactionResponseBody, UserResponseBody } from '@/srm/lib/types'

export const isUserResponse = (a: unknown): a is UserResponseBody => !!(a as UserResponseBody)?.retourUtil
export const isTransactionResponse = (a: unknown): a is TransactionResponseBody => !!(a as TransactionResponseBody)?.retourTrans
export const isCertificateResponse = (a: unknown): a is CertificateResponse => !!(a as CertificateResponse)?.retourCertif
export const isDocumentResponse = (a: unknown): a is DocumentResponseBody => !!(a as DocumentResponseBody)?.retourDoc
